module.exports = __webpack_public_path__ + "img/headIcon.628198fe.png";